import * as Yup from 'yup'
import i18next from 'i18next'

export const AssignPremiseSchema = () => Yup.object({
    role_id: Yup.string().required(i18next.t('user.error_role')),
    user_id: Yup.string().required('Xpress Admin is required'),
    premise_id: Yup.array().min(1, 'Select at least one premise').required('Premises is required'),
})
